// extracted by mini-css-extract-plugin
export default {"selector":"B9","disabled":"C9","hed":"E9","selected":"F9","subHed":"G9","standard":"H9","flavor":"I9","flavorImage":"J9","long":"K9"};
    if(module.hot) {
      // 1715188240743
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  